import { render, staticRenderFns } from "./ps-multi-image-text.vue?vue&type=template&id=4c24aedc&"
import script from "./ps-multi-image-text.js?vue&type=script&lang=js&"
export * from "./ps-multi-image-text.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports